import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

const Modal = ({ isOpen, onClose, title, children }: ModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        {title && (
          <DialogHeader
            className="px-[33px] py-5 rounded-t-[8px] bg-surface-input"
          >
            <DialogTitle className="text-content-heading">{title}</DialogTitle>
          </DialogHeader>
        )}
        <div className="overflow-y-auto flex-1 [&>*]:rounded-t-none">
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
